<!--
/**
 * DjNoShutdownTab.vue - 取消停机保号 Tab 组件
 *
 * 【功能说明】
 * 本组件是迪加(DJ)虚拟商品管理系统的取消停机保号管理页面，
 * 用于取消号码的停机保号状态，支持手动输入和文件上传两种模式，
 * 同时提供停机保号设置和迪加套餐管理功能。
 *
 * 【主要功能】
 * 1. 取消停机保号记录查询 - 按号码搜索取消停机保号的历史记录
 * 2. 手动取消停机保号 - 手动输入号码取消停机保号
 * 3. 文件上传取消 - 通过上传txt文件批量取消停机保号
 * 4. 停机保号设置 - 开启/关闭自动取消停机保号功能
 * 5. 迪加套餐管理 - 管理迪加套餐金额列表（动态增删）
 *
 * 【权限要求】
 * - 所有用户：可执行所有操作
 -->
<template>
  <div>
    <!-- ========== 搜索区域 ========== -->
    <div class="handle-box">
      <!-- 号码输入框 -->
      <el-input size="small" v-model="query5.phone" clearable maxlength="12" placeholder="号码"
                style="width: 180px;" class="handle-input mr10"></el-input>
      <!-- 搜索按钮 -->
      <el-button size="small" type="primary" :class="[theme]" icon="el-icon-search" class="m_t_10"
                 @click="getcancelProtectionList">搜索
      </el-button>
      <!-- 取消停机保号按钮 -->
      <el-button size="small" type="primary" :class="[theme]" @click="handleAdd5">取消停机保号</el-button>
      <!-- 停机保号设置按钮 -->
      <el-button size="small" type="primary" :class="[theme]" @click="getMaintenanceSet"
                 class="m_t_10">停机保号设置
      </el-button>
      <!-- 迪加套餐管理按钮 -->
      <el-button size="small" type="primary" :class="[theme]" @click="showDxtPackage"
                 class="m_t_10">迪加套餐
      </el-button>
    </div>

    <!-- ========== 取消停机保号记录表格 ========== -->
    <el-table :data="tableData5" border class="table" ref="multipleTable" max-height="600"
              header-cell-class-name="table-header" :row-style="{ height: '20px' }"
              :cell-style="{ padding: '6px' }" :header-cell-style="{ 'text-align': 'center' }" stripe
              v-loading="loading">
      <!-- 手机号 -->
      <el-table-column prop="phone" label="手机号" align="center"></el-table-column>
      <!-- 状态（失败时红色显示，悬浮提示错误信息） -->
      <el-table-column prop="status" label="状态" align="center">
        <template #default="scope">
          <el-tooltip class="item" effect="dark" :content="scope.row.errMsg" placement="top"
                      v-if="scope.row.status == '失败'">
            <span style="color: #f56c6c;">{{ scope.row.status }}</span>
          </el-tooltip>
          <span v-else>{{ scope.row.status }}</span>
        </template>
      </el-table-column>
      <!-- 备注 -->
      <el-table-column prop="remark" label="备注" align="center"></el-table-column>
      <!-- 时间 -->
      <el-table-column prop="time" label="时间" align="center"></el-table-column>
      <!-- 操作者 -->
      <el-table-column prop="userPhone" label="操作者" align="center"></el-table-column>
    </el-table>

    <!-- ========== 分页器 ========== -->
    <div class="pagination">
      <el-pagination background layout="total, sizes, prev, pager, next, jumper"
                     :current-page="query5.pageIndex" :page-sizes="[10, 20, 50, 100, 200, 500]"
                     :page-size="query5.pageSize" :total="pageTotal5" @size-change="handleSizeChange"
                     @current-change="handlePageChange"></el-pagination>
    </div>

    <!-- ========== 取消停机保号弹窗 ========== -->
    <!-- 支持手动输入和文件上传两种模式 -->
    <el-dialog title="取消停机保号" v-model="addVisible5" width="520px" @close="closeDialog5">
      <el-form label-width="120px" :model="addForm5" ref="addForm5">
        <!-- 选择模式 -->
        <el-form-item label="选择模式" prop="tab1">
          <el-radio-group v-model="tab1">
            <el-radio label="input">手动输入</el-radio>
            <el-radio label="fled">文件上传</el-radio>
          </el-radio-group>
        </el-form-item>
        <!-- 手动输入模式 -->
        <el-form-item label="手机号码" prop="phones" v-if="tab1 == 'input'">
          <el-input size="small" :rows="5" type="textarea" v-model="addForm5.phones" auto-complete="off"
                    placeholder="一行一个手机号码,一次最多添加500个号码"></el-input>
        </el-form-item>
        <!-- 文件上传模式 -->
        <el-form-item label="上传文件" prop="" v-else>
          <el-upload ref="upload5" action="/api/dxt/FileCancel" :headers="token" :limit="1"
                     :on-success="uploadSuccess5" :auto-upload="false" :data="addForm5">
            <el-button size="small" type="primary" :class="[theme]"
                       style="margin-top: 40px;">选择文件
            </el-button>
            <div class="el-upload__tip">只能导入txt文件</div>
          </el-upload>
        </el-form-item>
        <!-- 取消停机保号原因 -->
        <el-form-item label="原因" prop="remark">
          <el-input size="small" :rows="2" type="textarea" v-model="addForm5.remark" auto-complete="off"
                    placeholder="请输入取消停机保号原因"></el-input>
        </el-form-item>
        <el-form-item class="dis-end">
          <el-button size="small" @click="closeDialog5">取消</el-button>
          <el-button size="small" type="primary" :class="[theme]" v-if="tab1 == 'input'"
                     @click="submitAdd">确定
          </el-button>
          <el-button size="small" type="primary" :class="[theme]" v-else @click="submitUpload5">确定</el-button>
        </el-form-item>
      </el-form>
    </el-dialog>

    <!-- ========== 停机保号设置弹窗 ========== -->
    <!-- 设置是否自动取消停机保号 -->
    <el-dialog title="停机保号设置" v-model="maintenanceVisible" width="450px" @close="closeMaintenanceDialog">
      <el-form label-width="120px" :model="maintenanceForm" ref="maintenanceForm">
        <el-form-item label="自动取消停机保号:" prop="enable">
          <el-radio-group v-model="maintenanceForm.enable">
            <el-radio :label="true">开启</el-radio>
            <el-radio :label="false">关闭</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item class="dis-end">
          <el-button size="small" @click="closeMaintenanceDialog">取消</el-button>
          <el-button size="small" type="primary" :class="[theme]" @click="updateCancellation">确定</el-button>
        </el-form-item>
      </el-form>
    </el-dialog>

    <!-- ========== 迪加套餐管理弹窗 ========== -->
    <!-- 动态管理迪加套餐金额列表，支持增删套餐金额 -->
    <el-dialog title="迪加套餐" v-model="dxtPackageVisible" width="850px" @close="closeDxtPackageDialog">
      <el-form label-width="120px" :model="dxtPackageForm" ref="dxtPackageForm">
        <!-- 动态渲染套餐金额列表 -->
        <el-form-item label="套餐" prop="cardsId" v-for="(item,index) in dxtPackageForm.menuList" :key="index">
          <!-- 套餐金额输入框 -->
          <el-input size="small" style="width: 200px;margin-right: 10px;margin-top: 4px;" v-model="item.value"
                    placeholder="请输入套餐金额">
            <template #append>元</template>
          </el-input>
          <!-- 添加套餐按钮 -->
          <el-button type="primary" icon="el-icon-plus" size="small" @click.prevent="addDomain()"/>
          <!-- 删除套餐按钮 -->
          <el-button type="danger" icon="el-icon-minus" size="small" @click.prevent="removeDomain(item)"/>
        </el-form-item>
        <el-form-item class="dis-end">
          <el-button size="small" @click="closeDxtPackageDialog">取消</el-button>
          <el-button size="small" type="primary" :class="[theme]" @click="updateDxtPackages">确定</el-button>
        </el-form-item>
      </el-form>
    </el-dialog>
  </div>
</template>

<script>
/**
 * 取消停机保号 Tab 组件脚本部分
 *
 * 引入的 API 接口：
 * - cancelProtection：执行取消停机保号
 * - cancelProtectionList：查询取消停机保号记录
 * - updateCancellation：更新停机保号设置（自动取消开关）
 * - getCancellation：查询当前停机保号设置
 * - getDxtPackage：获取迪加套餐列表
 * - updateDxtPackage：更新迪加套餐列表
 */
import {
  cancelProtection,
  cancelProtectionList,
  updateCancellation,
  getCancellation,
  getDxtPackage,
  updateDxtPackage
} from '../../../api/dijia.js';

export default {
  name: 'DjNoShutdownTab',

  /**
   * 【Props 接收的参数】
   * - theme：主题颜色样式类名
   * - token：请求头信息（包含认证令牌），用于文件上传鉴权
   */
  props: {
    theme: { type: String, default: '' },
    token: { type: Object, default: () => ({}) },
  },

  data() {
    return {
      // ========== 查询相关 ==========
      loading: false,           // 表格加载状态
      query5: {                 // 查询参数
        userId: localStorage.getItem('user'),
        phone: '',              // 手机号
        pageIndex: 1,           // 当前页码
        pageSize: 10,           // 每页条数
      },
      tableData5: [],           // 记录列表
      pageTotal5: 0,            // 总条数

      // ========== 取消停机保号弹窗相关 ==========
      addVisible5: false,       // 弹窗是否显示
      addForm5: {               // 表单数据
        phones: '',             // 手机号（一行一个）
        userId: localStorage.getItem('user'),
        remark: '',             // 取消原因
      },
      tab1: 'input',            // 当前模式（input=手动，fled=文件）

      // ========== 停机保号设置弹窗相关 ==========
      maintenanceVisible: false,  // 设置弹窗是否显示
      maintenanceForm: {        // 设置表单
        enable: false,          // 是否开启自动取消停机保号
        userId: localStorage.getItem('user'),
      },

      // ========== 迪加套餐弹窗相关 ==========
      dxtPackageVisible: false, // 套餐弹窗是否显示
      dxtPackageForm: {
        prices: [],             // 套餐金额数组（提交用）
        menuList: [{ value: '' }],  // 动态列表（页面展示用，含增删按钮）
      },
    };
  },

  /**
   * 组件创建时查询取消停机保号记录列表
   */
  created() {
    this.getcancelProtectionList();
  },

  methods: {
    /**
     * getcancelProtectionList - 查询取消停机保号记录列表
     */
    getcancelProtectionList() {
      this.loading = true;
      cancelProtectionList(this.query5).then(res => {
        this.loading = false;
        if (res?.code === 200) {
          this.tableData5 = res.data.list;
          this.pageTotal5 = res.data.total;
        } else {
          this.$message.error(res.message);
        }
      });
    },

    /**
     * handleAdd5 - 打开取消停机保号弹窗
     */
    handleAdd5() {
      this.addVisible5 = true;
    },

    /**
     * submitAdd - 手动输入模式提交取消停机保号
     */
    submitAdd() {
      cancelProtection(this.addForm5).then(res => {
        if (res?.code === 200) {
          this.addVisible5 = false;
          this.$message.success(res.data);
          this.getcancelProtectionList();
        } else {
          this.$message.error(res.message);
        }
      });
    },

    /**
     * submitUpload5 - 文件上传模式提交
     */
    submitUpload5() {
      if (this.$refs.upload5.uploadFiles[0]) {
        this.loading = true;
        this.$refs.upload5.submit();
      } else {
        this.$message.error('请选择上传文件');
      }
    },

    /**
     * closeDialog5 - 关闭取消停机保号弹窗并重置表单
     */
    closeDialog5() {
      this.addVisible5 = false;
      this.addForm5.phones = '';
      this.addForm5.operateMsg = '';
      this.addForm5.remark = '';
      this.tab1 = 'input';
    },

    /**
     * uploadSuccess5 - 文件上传成功回调
     * @param {Object} success - 上传接口返回结果
     */
    uploadSuccess5(success) {
      setTimeout(() => {
        this.$refs.upload5.clearFiles();
        this.addVisible5 = false;
      }, 2000);
      if (success?.code === 200) {
        this.$message.success('上传成功');
        this.getcancelProtectionList();
      } else {
        this.$message.error(success.message);
      }
    },

    /**
     * getMaintenanceSet - 打开停机保号设置弹窗
     * 先查询当前设置状态，再显示弹窗
     */
    getMaintenanceSet() {
      this.maintenanceVisible = true;
      this.getCancellations();
    },

    /**
     * getCancellations - 查询当前停机保号设置状态
     */
    getCancellations() {
      getCancellation(localStorage.getItem('user')).then(res => {
        if (res?.code === 200) {
          this.maintenanceForm.enable = res.data;
        } else {
          this.$message.error(res.message);
        }
      });
    },

    /**
     * closeMaintenanceDialog - 关闭停机保号设置弹窗
     */
    closeMaintenanceDialog() {
      this.maintenanceVisible = false;
    },

    /**
     * updateCancellation - 提交停机保号设置
     */
    updateCancellation() {
      updateCancellation(this.maintenanceForm).then(res => {
        if (res?.code === 200) {
          this.maintenanceVisible = false;
          this.$message.success(res.message);
        } else {
          this.$message.error(res.message);
        }
      });
    },

    /**
     * showDxtPackage - 打开迪加套餐管理弹窗
     * 清空表单后从接口加载现有套餐列表
     */
    showDxtPackage() {
      this.dxtPackageForm.prices = [];
      this.dxtPackageForm.menuList = [];
      this.getDxtPackages();
      this.dxtPackageVisible = true;
    },

    /**
     * addDomain - 添加一个新的套餐金额输入项
     */
    addDomain() {
      this.dxtPackageForm.menuList.push({ value: '' });
    },

    /**
     * removeDomain - 删除指定的套餐金额输入项
     * @param {Object} item - 要删除的套餐项
     */
    removeDomain(item) {
      var index = this.dxtPackageForm.menuList.indexOf(item);
      if (index !== -1) {
        this.dxtPackageForm.menuList.splice(index, 1);
      }
    },

    /**
     * closeDxtPackageDialog - 关闭迪加套餐弹窗
     */
    closeDxtPackageDialog() {
      this.dxtPackageVisible = false;
    },

    /**
     * updateDxtPackages - 提交迪加套餐更新
     * 将菜单列表中的金额提取为逗号分隔的字符串提交
     */
    updateDxtPackages() {
      this.dxtPackageForm.menuList.forEach(i => {
        this.dxtPackageForm.prices.push(i.value);
      });
      let data = { prices: this.dxtPackageForm.prices.join(',') };
      updateDxtPackage(data).then(res => {
        if (res?.code === 200) {
          this.getcancelProtectionList();
          this.dxtPackageVisible = false;
        } else {
          this.$message.error(res.message);
        }
      });
    },

    /**
     * getDxtPackages - 获取迪加套餐列表
     * 从接口加载套餐金额并填充到menuList中
     */
    getDxtPackages() {
      getDxtPackage().then(res => {
        if (res?.code === 200) {
          res.data.forEach(item => {
            this.dxtPackageForm.menuList.push({ value: item });
          });
        } else {
          this.$message.error(res.message);
        }
      });
    },

    /**
     * handlePageChange - 翻页回调
     * @param {number} val - 新的页码
     */
    handlePageChange(val) {
      this.query5.pageIndex = val;
      this.getcancelProtectionList();
    },

    /**
     * handleSizeChange - 每页条数变化回调
     * @param {number} val - 新的每页条数
     */
    handleSizeChange(val) {
      this.query5.pageSize = val;
      this.query5.pageIndex = 1;
      this.getcancelProtectionList();
    },
  }
};
</script>

<style scoped>
@import './tab-styles.css';
</style>
